<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">PREFACE</h2>
<p class="noindent"><span class="dropcap">I</span> refer readers to my Swansea to Llanelly volume (published by Wild Swan Ltd.) in the series on the South Wales Main Line in which the Introduction gives a history of the development of rail services west of Swansea from the Victorian era through to the end of steam in the 1960s. I commend this to readers of this volume and ask them to study this as otherwise it would be necessary for me to repeat it in each succeeding volume. Carmarthen was dealt with in detail in the preceding volume, Llanelly West to Carmarthen, so this volume completes the section on the county town with some shots of trains leaving that location, and showing the famous river bridge over the Teifi and the railway beyond.</p>
<p class="indent">I also commend readers to the 1987 Wild Swan book <em class="italic">Edwardian Enterprise</em> by John Norris which contains a detailed account of the building and opening of Fishguard Harbour.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Preface.vue?8d1a2f7a